import React from "react";
import site from "../../config/site";

const {
  blog: { posts },
} = site;

const Blog = () => {
  return (
    <>
      {posts.map((post) => (
        <div key={post.url} className="col-12 col-md-6 col-lg-6 col-xl-4 mb-30">
          <article className="post-container">
            <div className="post-thumb">
              <div className="d-block position-relative overflow-hidden">
                <a target="_blank" href={post.url} rel="noreferrer">
                  <img src={post.image} className="img-fluid" alt={post.title} />
                </a>
              </div>
            </div>
            {/* End .thumb */}
            <div className="post-content">
              <div className="entry-header">
                <a target="_blank" href={post.url} rel="noreferrer">
                  <h3>{post.title}</h3>
                </a>
              </div>
            </div>
            {/* End .post-content */}
          </article>
        </div>
      ))}
    </>
  );
};

export default Blog;
